/**
 * Sign in for the private lesson patterns (header info menu → Sign in).
 *
 * The patterns are not in the app: `fetchLessonPatterns()` asks `/api/lesson-patterns`
 * for them with the password. A password that worked is kept in localStorage so the
 * browser stays signed in; Sign out removes it. Every storage access is wrapped, so
 * blocked storage just means signing in again next visit.
 */

export const LESSON_PASSWORD_KEY = 'scalebase-lesson-password';

export const LESSON_ENDPOINT = '/api/lesson-patterns';

export function getSavedLessonPassword() {
  try {
    return localStorage.getItem(LESSON_PASSWORD_KEY);
  } catch {
    return null;
  }
}

export function saveLessonPassword(password) {
  try {
    localStorage.setItem(LESSON_PASSWORD_KEY, password);
  } catch {
    // Signed in for this visit only.
  }
}

export function clearLessonPassword() {
  try {
    localStorage.removeItem(LESSON_PASSWORD_KEY);
  } catch {
    // Nothing stored.
  }
}

/**
 * Resolves to the pattern data, or rejects with an Error whose `reason` is
 * 'wrong_password', 'not_configured' (no LESSON_PASSWORD set) or 'network'.
 */
export async function fetchLessonPatterns(password) {
  let res;
  try {
    res = await fetch(LESSON_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
      cache: 'no-store',
    });
  } catch {
    throw Object.assign(new Error('network'), { reason: 'network' });
  }
  if (res.status === 401) throw Object.assign(new Error('wrong_password'), { reason: 'wrong_password' });
  if (res.status === 503) throw Object.assign(new Error('not_configured'), { reason: 'not_configured' });
  if (!res.ok) throw Object.assign(new Error('network'), { reason: 'network' });
  try {
    return await res.json();
  } catch {
    throw Object.assign(new Error('network'), { reason: 'network' });
  }
}
